"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleSet = require("./RuleSet");

var _RuleSet2 = _interopRequireDefault(_RuleSet);

var _RulesCollection = require("./RulesCollection");

var _RulesCollection2 = _interopRequireDefault(_RulesCollection);

var _Field = require("./Field");

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = function () {
    function Validator() {
        var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var ruleSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Validator);

        this.form = form;
        this.errors = {};
        this.ruleSet = new _RuleSet2.default(ruleSet);
        this.currentfield = '';
        this.parentfields = [];
        this.setValidationRules();
    }

    _createClass(Validator, [{
        key: "setCurrentField",
        value: function setCurrentField(name) {
            this.currentfield = new _Field2.default(name, this.getFieldValue(name));
        }
    }, {
        key: "validate",
        value: function validate() {
            this.setErrorsInRuleSet(this.ruleSet);

            return this.errors;
        }
    }, {
        key: "setErrorsInRuleSet",
        value: function setErrorsInRuleSet(ruleSet) {
            for (var fieldName in ruleSet) {
                this.setCurrentField(fieldName);
                var errors = this.getErrorsInCurrentField(ruleSet);
                this.setErrors(errors);
            }
            this.parentfields.pop();
        }
    }, {
        key: "getErrorsInCurrentField",
        value: function getErrorsInCurrentField(ruleSet) {
            if (ruleSet.isParentField(this.currentfield.name)) {
                this.validateChildRuleSet(ruleSet);
            }

            return this.ruleCollection.runValidationsAndGetErrors(ruleSet, this.currentfield);
        }
    }, {
        key: "validateChildRuleSet",
        value: function validateChildRuleSet(ruleSet) {
            this.parentfields.push(this.currentfield.name);
            this.setErrorsInRuleSet(ruleSet.getRulesInField(this.currentfield.name));
        }
    }, {
        key: "validateField",
        value: function validateField(fieldName) {
            var errors = void 0;
            var ruleSet = this.setUpSingleFieldValidation(fieldName);
            errors = this.getErrorsInCurrentField(ruleSet);

            this.setErrors(errors);
            if (errors.length < 1) {
                this.removeErrorFromCurrentField();
            }

            return errors;
        }
    }, {
        key: "setUpSingleFieldValidation",
        value: function setUpSingleFieldValidation(fieldName) {
            this.setCurrentField(fieldName);
            var ruleSet = this.ruleSet;

            if (fieldName.indexOf('.')) {
                var fieldNames = fieldName.split('.');
                this.setParentFields(fieldNames);
                this.setCurrentFieldNested(fieldNames);
                ruleSet = ruleSet.getNestedRuleSet(fieldNames);
            }
            return ruleSet;
        }
    }, {
        key: "setCurrentFieldNested",
        value: function setCurrentFieldNested(fieldNames) {
            this.setCurrentField(fieldNames[fieldNames.length - 1]);
        }
    }, {
        key: "setParentFields",
        value: function setParentFields(fieldNames) {
            for (var i = 0; i < fieldNames.length - 1; i++) {
                this.parentfields.push(fieldNames[i]);
            }
        }
    }, {
        key: "removeErrorFromCurrentField",
        value: function removeErrorFromCurrentField() {
            var errors = this.errors;
            for (var i in this.parentfields) {
                errors = errors[this.parentfields[i]];
            }

            if (errors === undefined) {
                return;
            }

            errors[this.currentfield.name] = [];
        }
    }, {
        key: "getError",
        value: function getError(field) {
            if (!this.fails()) {
                return;
            }

            var error = this.getNestedError(field);

            return error ? error[0] : null;
        }
    }, {
        key: "getNestedError",
        value: function getNestedError(field) {
            var errors = this.errors;

            if (field.indexOf('.')) {
                var fields = field.split('.');
                for (var i in fields) {
                    errors = errors[fields[i]];
                }
                return errors;
            }
            return errors[field];
        }
    }, {
        key: "setErrors",
        value: function setErrors(errors) {
            if (!this.errorsAreSet(errors)) {
                return;
            }

            if (this.hasParentField()) {
                this.nestErrorsInParent(errors);
            } else {
                this.errors[this.currentfield.name] = errors;
            }
        }
    }, {
        key: "nestErrorsInParent",
        value: function nestErrorsInParent(newErrors) {
            var errors = this.errors;

            for (var i in this.parentfields) {
                var parent = this.parentfields[i];
                if (!errors[parent]) {
                    errors[parent] = {};
                }
                errors = errors[parent];
            }
            errors[this.currentfield.name] = newErrors;
        }
    }, {
        key: "getFieldValue",
        value: function getFieldValue(fieldName) {
            if (this.hasParentField()) {
                return this.getChildFieldValue(fieldName);
            }

            return this.form[fieldName];
        }
    }, {
        key: "getChildFieldValue",
        value: function getChildFieldValue(fieldName) {
            var form = this.form;

            for (var parent in this.parentfields) {
                form = form[this.parentfields[parent]];
            }

            return form[fieldName];
        }
    }, {
        key: "hasParentField",
        value: function hasParentField() {
            return this.parentfields.length > 0;
        }
    }, {
        key: "errorsAreSet",
        value: function errorsAreSet(errors) {
            return errors !== undefined && errors.length > 0;
        }
    }, {
        key: "fails",
        value: function fails() {
            return Object.keys(this.errors).length > 0;
        }
    }, {
        key: "setValidationRules",
        value: function setValidationRules() {
            var ruleCollection = _RulesCollection2.default.default();
            ruleCollection.extend(this.customRules());

            this.ruleCollection = ruleCollection;
        }
    }, {
        key: "customRules",
        value: function customRules() {
            return {};
        }
    }]);

    return Validator;
}();

exports.default = Validator;